export {default as Faq} from './faq'